export function getUrlHost(): string {
      const urlHost = window.location.origin;
      return urlHost;
}  
